module.exports = __webpack_public_path__ + "img/anthony-fomin-sTw2KYpoujk-unsplash.b37d13b5.jpg";